import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import logo from "./logo.svg";
import "./App.css";
import ViewBans from "./components/pages/viewBans";
import { MantineProvider } from "@mantine/core";

const App = () => (
  <MantineProvider
    theme={{
      // Override any other properties from default theme
      fontFamily: "Andika New Basic",
      spacing: { xs: 15, sm: 20, md: 25, lg: 30, xl: 40 },
      colorScheme: "dark",
    }}
  >
    <ViewBans />
  </MantineProvider>
);

export default App;
